import { ReactNode } from "react";
import { SWRConfig } from "swr";

type SWRWrapperProps = {
  children: ReactNode;
};

const SWRWrapper = ({ children }: SWRWrapperProps) => {
  return (
    <SWRConfig
      value={{
        refreshInterval: 30 * 1000,
      }}
    >
      {children}
    </SWRConfig>
  );
};

export default SWRWrapper;
